export const Filter = ({ size = 16, className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.66674 3.33398H12.3334C12.528 3.40222 12.68 3.55665 12.7452 3.75227C12.8104 3.94788 12.7815 4.16265 12.6667 4.33398L9.33341 8.00065V12.6673L6.66674 10.6673V8.00065L3.33341 4.33398C3.21869 4.16265 3.18971 3.94788 3.25492 3.75227C3.32012 3.55665 3.47217 3.40222 3.66674 3.33398"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
